import * as React from 'react';

const ProductBlockHeader = ({ children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "v2-product-block-header"
    }, children);
};

export { ProductBlockHeader };
//# sourceMappingURL=ProductBlockHeader.js.map
